import ContactModal from "@/components/ContactModal";
import styles from "./index.module.less";
import { isMobile } from "@/utils";
import MobileContactPage from "./mobile";
import ContactMain from "@/components/ContactModal/components/Main";
const ContactPage = () => {
  return (
    <div className={styles.contact}>
      <ContactMain />
    </div>
  );
};
export default isMobile() ? MobileContactPage : ContactPage;
